import { createFileRoute } from '@tanstack/react-router';

import { ExternalReportingDetailPage } from '@/features/external-reporting/components';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/external-reporting/$reportId')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.externalReportingDetails'),
  }),
  component: ExternalReportingDetailRoute,
});

function ExternalReportingDetailRoute() {
  const { reportId } = Route.useParams();
  return <ExternalReportingDetailPage reportId={reportId} />;
}
